import React from 'react'
import { allRoles, customRoles, roleItems } from 'keys/roles'
import { Chip } from 'components/Form'
import { RolesCellStyles } from './Style'

const RolesCell = (props) => {
    const { role } = props

    let item = roleItems?.[role.name]

    return (
        <RolesCellStyles>
            <Chip color={item?.color} >
                {role.label}
            </Chip>
        </RolesCellStyles>
    )
}

export default RolesCell